module.exports = __webpack_public_path__ + "img/truckHead-green.8436b019.svg";